/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Quality_GatesInputs */

const en_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality gates`)
};

const ar_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابات الجودة`)
};

const bn_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মান গেট`)
};

const de_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualitäts-Gates`)
};

const es_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puertas de calidad`)
};

const fr_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portes de qualité`)
};

const pt_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portas de qualidade`)
};

const zh_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量门禁`)
};

const tr_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalite kapıları`)
};

const ru_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ворота качества`)
};

const pl_svchip_quality_gates = /** @type {(inputs: Svchip_Quality_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bramki jakości`)
};

/**
* | output |
* | --- |
* | "Quality gates" |
*
* @param {Svchip_Quality_GatesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_quality_gates = /** @type {((inputs?: Svchip_Quality_GatesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Quality_GatesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_quality_gates(inputs)
	if (locale === "bn") return bn_svchip_quality_gates(inputs)
	if (locale === "de") return de_svchip_quality_gates(inputs)
	if (locale === "es") return es_svchip_quality_gates(inputs)
	if (locale === "fr") return fr_svchip_quality_gates(inputs)
	if (locale === "pt") return pt_svchip_quality_gates(inputs)
	if (locale === "zh") return zh_svchip_quality_gates(inputs)
	if (locale === "tr") return tr_svchip_quality_gates(inputs)
	if (locale === "ru") return ru_svchip_quality_gates(inputs)
	if (locale === "pl") return pl_svchip_quality_gates(inputs)
	return en_svchip_quality_gates(inputs)
});